import { TrainingConfigurationsProvider } from "./components/TrainingConfiguration";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthProvider from "./accounts/AuthProvider";
import AccountPreferencesProvider from "./accounts/AccountPreferencesProvider";
import SavedChartsProvider from "./accounts/SavedChartsProvider";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/index";
import { RouterProvider, createBrowserRouter } from "react-router-dom";


// The build generates sitemap.xml from these routes and registered content.
// /library/* will accept any subpath of library
const router = createBrowserRouter([
  { path: "/", element: <App page={"home"}/> },
  { path: "/library/*", element: <App page={"library"}/> },
  { path: "/support", element: <App page={"support"}/> },
  { path: "/edit", element: <App page={"home"}/> }, /* was edit  so keeping for legacy */
  { path: "/publish", element: <App page={"publish"}/> },
  { path: "/privacy", element: <App page={"privacy"}/> },
  { path: "/terms", element: <App page={"terms"}/> },
  { path: "/training", element: <App page={"training"}/> },
  { path: "/fretboard", element: <App page={"fretboard"}/> },
  { path: "/metronome", element: <App page={"metronome"}/> },
  { path: "/my-charts", element: <App page={"my-charts"}/> },
  { path: "/account", element: <App page={"account"}/> },
  { path: "/account/invite", element: <App page={"account"}/> },
  { path: "/account/callback", element: <App page={"account"}/> },
  { path: "/account/reset-password", element: <App page={"account"}/> },
  { path: "/admin", element: <App page={"admin"}/> },
  { path: "/blog/*", element: <App page={"blog"}/> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider><SavedChartsProvider><AccountPreferencesProvider><TrainingConfigurationsProvider><RouterProvider router={router} /></TrainingConfigurationsProvider></AccountPreferencesProvider></SavedChartsProvider></AuthProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
